import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { identitySchema } from '@/core/components';

export const researchCenterSchema = z.object({
  name: z.string().min(3),
  description: z.string().optional().nullable(),
  creationDate: z.date(),
  director: identitySchema,
  sciDirector: identitySchema.optional().nullable(),
  researchDomain: z.string().optional().nullable(),
  doctoralStudentsNo: z.number().optional().nullable(),
  personsWithDoctorDegreeNo: z.number().optional().nullable(),
  professorsNo: z.number().optional().nullable(),
  associateProfessorsNo: z.number().optional().nullable(),
  managersTotalNo: z.number().optional().nullable(),
  assistantProfessorsNo: z.number().optional().nullable(),
  researchersINo: z.number().optional().nullable(),
  researchersIINo: z.number().optional().nullable(),
  researchersIIINo: z.number().optional().nullable(),
  scientificResearchersNo: z.number().optional().nullable(),
  researchAssistantsNo: z.number().optional().nullable(),
  researchInfrastructure: z.string().optional().nullable(),
  activityVisibility: z.string().optional().nullable(),
  researchAchievements: z.string().optional().nullable(),
});

export const defaultResearchCenterValues: DefaultValues<ResearchCenterSchema> = {
  name: '',
};

export type ResearchCenterSchema = z.infer<typeof researchCenterSchema>;
